import { ShortcutKey } from '@components'

import { Color, Divider, Flex, Space, Spacing, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { EInvoiceStatus } from '@features/eInvoicing/constants/eInvoiceStatus'

import { ALT_SHORTCUT, CMD_SHORTCUT } from '../../../../constants/shortcuts'
import { isMac } from '../../../../utils/isMac'
import { useBillForm } from '../BillEditableForm/contexts/billFormContext'

export const metakeyLabel = isMac ? '⌘' : 'Ctrl'

export const AttachmentShortcuts = () => {
  const { t } = useTranslation()
  const { isLifecycleLocked, eInvoiceStatus } = useBillForm()
  const isRefused = eInvoiceStatus === EInvoiceStatus.Refused

  return (
    <>
      <Space size="s24" />

      <Divider dividerColor={Color.Grey200} />
      <Space size="s32" />

      <Flex gap={Spacing.S24} alignItems="center">
        <Text variant="bodySM" uppercase colorVariant="secondary">
          {t('bill.attachment.shortcuts')}
        </Text>

        {!isRefused && !isLifecycleLocked && (
          <>
            <Flex alignItems="center" gap={Spacing.S8}>
              <Text variant="bodySM" colorVariant="secondary">
                {t('bill.attachment.approve_bill')}
              </Text>

              <ShortcutKey label={CMD_SHORTCUT} />
              <Text variant="bodySM" colorVariant="secondary">
                +
              </Text>
              <ShortcutKey label="enter" />
            </Flex>

            <Flex alignItems="center" gap={Spacing.S8}>
              <Text variant="bodySM" colorVariant="secondary">
                {t('bill.attachment.register_payment')}
              </Text>

              <ShortcutKey label={ALT_SHORTCUT} />
              <Text variant="bodySM" colorVariant="secondary">
                +
              </Text>
              <ShortcutKey label="p" />
            </Flex>
          </>
        )}

        <Flex alignItems="center" gap={Spacing.S8}>
          <Text variant="bodySM" colorVariant="secondary">
            {t('attachments.zoom_in_out')}
          </Text>

          <ShortcutKey label={t('attachments.scroll')} />
        </Flex>

        <Flex alignItems="center" gap={Spacing.S8}>
          <Text variant="bodySM" colorVariant="secondary">
            {t('attachments.navigate_between_pages')}
          </Text>

          <Flex alignItems="center" gap={Spacing.S4}>
            <ShortcutKey label="<" />
            <ShortcutKey label=">" />
          </Flex>
        </Flex>
      </Flex>

      <Space size="s24" />
    </>
  )
}
